export default __webpack_public_path__ + "static/media/btechBenefitImage.78ef4234.png";